import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAPfWX1Xyk_kNEK2jyVd_in9l3kkPFuXb4",
  authDomain: "deepak-react-whatsapp-clone.firebaseapp.com",
  databaseURL: "https://deepak-react-whatsapp-clone.firebaseio.com",
  projectId: "deepak-react-whatsapp-clone",
  storageBucket: "deepak-react-whatsapp-clone.appspot.com",
  messagingSenderId: "467378978660",
  appId: "1:467378978660:web:67f26951cb89907b4b4471",
  measurementId: "G-JV9VDJ198H",
});

const db = firebaseApp.firestore();
const auth = firebaseApp.auth();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

export { auth, googleAuthProvider };

export default db;
